import React, { useState } from "react";

import { Link, useLocation } from "react-router-dom";

import { Container, Flex } from "@chakra-ui/react";

import { logo, forward, back, circBack } from "../../assets";

import { Breakpoints } from "../../context";

export const Header = () => {
  const size = React.useContext(Breakpoints);
  const location = useLocation();

  const [path, setPath] = useState(location.pathname);

  if (location.pathname !== path) {
    setPath(location.pathname);
  }

  return (
    <header>
      {size === "mobile" ? (
        <Container
          p="0"
          minW={{ base: "305px" }}
          maxW={{ base: "305px" }}
          // centerContent
          mb={"45px"}
          mt={"45px"}
        >
          <Flex justifyContent="space-between" alignItems="center">
            <Link to="/">
              <img src={logo} alt="Felco Logo" width="142px" height="42px" />
            </Link>
            <Flex align="center">
              {path === "/" ? (
                <Link to="/font">
                  <img
                    src={forward}
                    alt="FElCO LOGO"
                    width="40px"
                    height="32px"
                  />
                </Link>
              ) : path === "/font" ? (
                <>
                  <Link to="/" style={{ marginRight: "12px" }}>
                    <img
                      src={back}
                      alt="FElCO LOGO"
                      width="40px"
                      height="32px"
                    />
                  </Link>
                  <Link to="/color-palette">
                    <img
                      src={forward}
                      alt="FElCO LOGO"
                      width="40px"
                      height="32px"
                    />
                  </Link>
                </>
              ) : (
                <>
                  <Link to="/font" style={{ marginRight: "12px" }}>
                    <img
                      src={circBack}
                      alt="FElCO LOGO"
                      width="40px"
                      height="32px"
                    />
                  </Link>
                </>
              )}
            </Flex>
            {/* <Box pr="4px">
              <Link to="/font">
                <img
                  src={forward}
                  alt="FElCO LOGO"
                  width="40px"
                  height="32px"
                />
              </Link>
            </Box> */}
          </Flex>
        </Container>
      ) : (
        <Container centerContent mb={"32px"}>
          <Link to="/">
            <img src={logo} alt="Felco Logo" />
          </Link>
        </Container>
      )}
    </header>
  );
};
